import axios from 'axios';
import Cookie from 'js-cookie';

const myAxiosApp = axios.create({
  headers: {
    'Auth-Token': Cookie.get('auth_token'),
    Language: I18n.locale
  }
});

myAxiosApp.setAuthToken = (authToken) => {
  myAxiosApp.defaults.headers = Object.assign({}, myAxiosApp.defaults.headers, { 'Auth-Token': authToken });
};

export default myAxiosApp;
